import { styled, Box, Card, BoxProps, CardProps } from '@mui/material'
import { ComponentType } from 'react'

export const StyledCard: ComponentType<CardProps> = styled( Card )( ( { theme } ) => ( {
	padding: theme.spacing( 2 ),
	marginTop: theme.spacing( 2 ),
	marginBottom: theme.spacing( 2 ),
	border: `2px solid ${theme.palette.grey[ 400 ]}`,
	boxShadow: 'none',
	borderRadius: '12px',
	maxWidth: '600px',
} ) )

export const ContentBox: ComponentType<BoxProps> = styled( Box )( {
	flex: 1,
} )
